import type { EmpyrealCrystalType } from '@sorrem/shared';

/** Resonance essence is colorless, so its crystal is a pale, near-white glass. */
export const CRYSTAL_TYPE_COLORS: Record<EmpyrealCrystalType, string> = {
    resonance: '#D9D6CC',
    vitality: '#4CAF50',
    insight: '#2196F3',
    warding: '#9C27B0',
    fury: '#F44336',
};

/** The crystal colors lifted for text on dark leather (coalesce recipe rows). */
export const CRYSTAL_TYPE_TEXT_COLORS: Record<EmpyrealCrystalType, string> = {
    resonance: '#e4e1d8',
    vitality: '#7fd68a',
    insight: '#7cc0f5',
    warding: '#c58ae0',
    fury: '#f07a6e',
};
